// import _ from "lodash";

var cache_ = {
  list: {},
  get: (key) => {
    if (typeof cache_.list[key] == "undefined") {
      return null;
    }
    if (cache_.list[key].expire < new Date().getTime()) {
      delete cache_.list[key];
      return null;
    }
    return cache_.list[key].data;
  },
  set: (key, data,ttl=10) => {
    cache_.list[key] = {
      data: data,
      expire: new Date().getTime() + ttl * 1000,
    };
  },
  clear:() => {
    this.list = {}
  }
};

export const cache = cache_



// WEBPACK FOOTER //
// ./src/libs/cache.js